/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import { useQuery, useApolloClient } from '@apollo/client';
import { getIn } from 'seamless-immutable';
import { useTestAB } from '@catalogo/core-experiments';
import { getPlacements, mergeComponents } from '@catalogo/service-americanas-common/src/helpers/template';
import config from '@catalogo/core-configuration/config/out/config.server.json';
import { useQueryProductReviews } from '@catalogo/service-americanas-product-review';
import { getDeferedProduct } from '../queries/defer.graphql';
import { seoProductInfo } from '../queries/seo-product-info.graphql';
import { getProductPage } from '../queries/product-page.graphql';
import { UseProductPageProps } from '../types';

export const useProductPage = ({
  path,
  routeId,
  productId,
  sellerId,
  offerId = '',
  dispatchMetrics,
}: UseProductPageProps) => {
  const client = useApolloClient();
  const hasOfferId = !!offerId;
  const { loading, called, data, error, refetch } = useQuery(getProductPage, {
    variables: {
      productId,
      sellerId,
      routeId,
      path,
      segmented: false,
      brandCardId: config.brandCardId,
      offerId,
      hasOfferId,
      hasProductServices: config?.brand === 'acom',
    },
    errorPolicy: 'all',
    onCompleted: data => {
      dispatchMetrics('page:load', data);
      dispatchMetrics('tiktok:viewContent', data);
    },
  });

  const sellerIdBuybox = getIn(data, ['product', 'skus', 0, 'offers', 'result', 0, 'seller', 'id'], '');
  const template = getIn(data, ['page', 'template'], {});
  const recPlacements = getPlacements('recommendation', template);
  const b2wAdsPlacements = getPlacements('b2wads', template);
  const newtailPlacements = getPlacements('newtail', template);
  const categoryId = getIn(data, ['page', 'breadcrumb', 0, 'id']);
  const term = getIn(data, ['page', 'breadcrumb', 0, 'name'], '');

  const { data: dataDefered } = useQuery(getDeferedProduct, {
    variables: {
      productId,
      categoryId,
      sellerId: sellerIdBuybox,
      recPlacements,
      b2wAdsPlacements,
      newtailPlacements,
      term,
      pageType: 'product',
    },
    skip: recPlacements.length < 1 && b2wAdsPlacements.length < 1 && newtailPlacements.length < 1,
    ssr: false,
    onCompleted: dataDefered => {
      dispatchMetrics('recommendation:load', mergeComponents(data, dataDefered));
    },
  });

  const reviewsQueries = useQueryProductReviews({ productId });

  const allData = mergeComponents(data, dataDefered) as {
    page: Record<string, string>;
    product: Record<string, string>;
  };

  client.writeQuery({
    query: seoProductInfo,
    data: {
      title: allData.page?.title,
      description: allData.page?.description,
      socialImages: allData.product?.images?.[0],
    },
  });

  const skuExperiment = useTestAB('CAT_021_VARIACOES_SKU');

  return {
    data: allData,
    error,
    called,
    loading,
    components: {},
    refetch,
    reviewsQueries,
    experiment: { skuExperiment },
  };
};
